export enum TypeClasses {
  Organization = 'organization',
  Experience = 'experience',
  Collection = 'collection'
}
